import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { softExpire } from "../util/soft_expire";

const readRawJwt = () => {
  const stored = localStorage.getItem("jwtToken");
  if (!stored) return null;
  return stored.replace(/^Bearer\s+/i, "");
};

export default function TokenExpiryWatcher() {
  useEffect(() => {
    const check = () => {
      // if already expired, stop
      if (window.__COSMETINK_SOFT_EXPIRED__) return;

      const jwt = readRawJwt();
      if (!jwt) return;

      try {
        const decoded = jwtDecode(jwt);
        const exp = decoded?.exp;
        const now = Date.now() / 1000;

        if (!exp || exp <= now) softExpire("expired");
      } catch (e) {
        softExpire("expired");
      }
    };

    check();
    const id = setInterval(check, 5000);
    return () => clearInterval(id);
  }, []);

  return null;
}
